import { colours } from '../theme/colours';

export type IntervalLabel = '1' | 'b2' | '2' | 'b3' | '3' | '4' | 'b5' | '5' | 'b6' | '6' | 'b7' | '7';

export interface IntervalInfo {
  label: IntervalLabel;
  name: string;
  semitones: number;
  colour: string;
}

export const INTERVALS: IntervalInfo[] = [
  { label: '1',  name: 'Root',            semitones: 0,  colour: colours.intervalRoot },
  { label: 'b2', name: 'Minor 2nd',       semitones: 1,  colour: colours.intervalOther },
  { label: '2',  name: 'Major 2nd',       semitones: 2,  colour: colours.intervalOther },
  { label: 'b3', name: 'Minor 3rd',       semitones: 3,  colour: colours.intervalThird },
  { label: '3',  name: 'Major 3rd',       semitones: 4,  colour: colours.intervalThird },
  { label: '4',  name: 'Perfect 4th',     semitones: 5,  colour: colours.intervalOther },
  { label: 'b5', name: 'Diminished 5th',  semitones: 6,  colour: colours.intervalFifth },
  { label: '5',  name: 'Perfect 5th',     semitones: 7,  colour: colours.intervalFifth },
  { label: 'b6', name: 'Minor 6th',       semitones: 8,  colour: colours.intervalOther },
  { label: '6',  name: 'Major 6th',       semitones: 9,  colour: colours.intervalOther },
  { label: 'b7', name: 'Minor 7th',       semitones: 10, colour: colours.intervalSeventh },
  { label: '7',  name: 'Major 7th',       semitones: 11, colour: colours.intervalSeventh },
];

export const INTERVAL_BY_LABEL: Record<IntervalLabel, IntervalInfo> = Object.fromEntries(
  INTERVALS.map(i => [i.label, i])
) as Record<IntervalLabel, IntervalInfo>;

export const INTERVAL_BY_SEMITONE: Record<number, IntervalInfo> = Object.fromEntries(
  INTERVALS.map(i => [i.semitones, i])
) as Record<number, IntervalInfo>;

export function getIntervalColour(label: IntervalLabel): string {
  return INTERVAL_BY_LABEL[label]?.colour ?? colours.intervalOther;
}
